<template>
  <el-cascader
    v-model="optionValue"
    :options="options"
    @change="handleChange"
    clearable
    :style="styleRef"
    :props="rolesProps"
    placeholder="请选择类目"
    :show-all-levels="showLevels"
    :filterable="true"
  >
  </el-cascader>
</template>
<script>
import { getCascadeCategory } from "@/api/category";
import { addChildNode } from "@/utils";

export default {
  props: {
    isRequired: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    widthStyle: {
      type: String,
      default: "100%"
    },
    styleRef: {
      type: Object
    },
    type: {
      type: String
    },
    showLevels: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value(val) {
      if (val && val.length !== 0) {
        this.firstGetCascadeList(val);
      }
    }
  },
  created() {
    this.getCascadeList(0);
    if (this.value) {
      this.firstGetCascadeList(this.value);
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      optionValue: this.value,
      options: [],
      rolesProps: {
        multiple: this.isMultiple, // 是否多选
        lazy: true,
        lazyLoad: this.cascaderLazyLoad,
        checkStrictly: true
      }
    };
  },
  methods: {
    /**
     * 首次处理数据显示问题
     */
    async firstGetCascadeList(optionValue) {
      const data = optionValue;
      if (data && data.length !== 0) {
        let currentOption = [];
        let currentData = [];
        const options = [];
        if (options.length === 0) {
          await this.packagingData(0).then(resp => {
            currentOption = resp || [];
          });
        } else {
          currentOption = options;
        }
        for (const pId of data) {
          if (pId && pId !== "") {
            currentData.push(pId);
            await this.packagingData(pId).then(newNode => {
              addChildNode(pId, newNode, currentOption);
            });
          }
        }
        this.options = currentOption;
        this.optionValue = currentData;
      }
    },
    /**
     * 查询级联标签
     */
    getCascadeList(parentId) {
      this.packagingData(parentId).then(resp => {
        this.options = resp || [];
      });
    },
    /**
     * 选中角色获取的值
     * @param node
     * @param resolve
     */
    cascaderLazyLoad(node, resolve) {
      if (!node.root) {
        this.packagingData(node.value || 0).then(data => {
          resolve(data);
        });
      }
    },
    /**
     * 节点选中的值
     * @param events
     */
    handleChange(events) {
      this.$emit("valueFunc", this.type, events);
    },
    // 查询数据
    async packagingData(parentId) {
      const params = {
        parentId
      };
      const resp = await getCascadeCategory(params);
      const arr = [];
      if (resp.bizcode === 100) {
        const data = resp.data;
        if (!data || data.length === 0) {
          return arr;
        }
        data.map(item => {
          arr.push({
            value: item.id,
            label: item.name,
            parentId: item.parentId
          });
        });
      }
      return arr;
    }
  },
  destroyed() {
    this.optionValue = [];
    this.options = [];
  }
};
</script>

<style scoped lang="scss"></style>
